const STORE_ACTIONS = {
  DATA_REQUEST_ISSUED: 'DATA_REQUEST_ISSUED',
  DATA_REQUEST_PROCESSING: 'DATA_REQUEST_PROCESSING',
  DATA_REQUEST_COMPLETED: 'DATA_REQUEST_COMPLETED'
};

const dataRequestedAction = ({ slice, path }) => {
  return {
    type: STORE_ACTIONS.DATA_REQUEST_ISSUED,
    payload: { slice, path, status: STORE_ACTIONS.DATA_REQUEST_ISSUED }
  };
};

const dataProcessingAction = ({ slice, path }) => {
  return {
    type: STORE_ACTIONS.DATA_REQUEST_PROCESSING,
    payload: { slice, path, status: STORE_ACTIONS.DATA_REQUEST_PROCESSING }
  };
};

const dataCompletedAction = ({ slice, path }) => {
  return {
    type: STORE_ACTIONS.DATA_REQUEST_COMPLETED,
    payload: { slice, path, status: STORE_ACTIONS.DATA_REQUEST_COMPLETED }
  };
};

export {
  dataRequestedAction,
  dataProcessingAction,
  dataCompletedAction,
  STORE_ACTIONS
};
